import { Component } from '@angular/core';
import { ItSpinnerComponent } from 'design-angular-kit';


@Component({
  selector: 'app-spinner',
  imports: [ItSpinnerComponent],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class SpinnerComponent {

}
